/** Canonical App Store listing (Apple redirects to the visitor's regional store). */
export const CENTLY_APP_STORE_URL =
  'https://apps.apple.com/app/cently-ai/id6760440430';

/** Canonical Google Play listing for the Cently Android app. */
export const CENTLY_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=ai.cently.app';
